<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>工人管理</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入姓名/电话/地址"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新建工人</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:otherPhone|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                'fpi-regex:_id|string#or': searchValue,
                beanName: 'labour',
                title: '工人管理'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state === 0"
                    @click.native="doEnable(scope.row)"
                  >
                    认证通过
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state === 1"
                    @click.native="doDisable(scope.row)"
                  >
                    取消认证
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="新建工人" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      >
        <template slot="address">
          <el-input v-model="formData.address" @blur="getGeocode"></el-input>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'labour',
  data() {
    window.$this = this;
    return {
      name: 'labour',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('labour', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:otherPhone|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/labour/query.do', params, res => {
        res.data.map(item => {
          item.avatar = [{ url: item.avatar || '' }];
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.$refs.formData) {
          this.$refs.form.$refs.formData.clearValidate();
        }
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        if (this.formData.avatar[0]) {
          if (this.formData.avatar[0].response) {
            this.formData.avatar = this.osg.downloadUrl + this.formData.avatar[0].response.key;
          } else {
            this.formData.avatar = this.formData.avatar[0].url;
          }
        }
        if (!this.formData._id) this.formData.state = 0; // 默认未认证
        this.osg.ajax('biz/labour/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      // this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doEnable(row) {
      this.osg.confirm(`是否确认认证通过“${row.name}”？`, () => {
        this.osg.ajax('biz/labour/enable.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doDisable(row) {
      this.osg.confirm(`是否确认取消认证“${row.name}”？`, () => {
        this.osg.ajax('biz/labour/disable.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除“${row.name}”？`, () => {
        this.osg.ajax('biz/labour/delete.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    getGeocode() {
      if (this.formData.address) {
        this.osg.geocode(
          this.formData.address,
          res => {
            this.formData.gpsPoint = {
              longitude: res.location.split(',')[0],
              latitude: res.location.split(',')[1]
            };
          },
          this.formData.area && this.formData.area.length == 3 ? this.formData.area[1] : ''
        );
      } else {
        this.formData.gpsPoint = {};
      }
    }
  }
};
</script>
